import { Button, Container, Icon, Spinner, TextInput, Typography } from 'gu-ui-kit'
import React, { useCallback, useEffect, useState } from 'react'
import { Collapse } from 'react-collapse'
import { useTranslation } from 'react-i18next'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import format from 'utils/formatMoney'
import useWriteToClipboard from 'utils/hooks/useWriteToClipboard'
import styles from 'modules/Referral/List/referral.module.scss'
import 'modules/Referral/List/referral.scss'
import ReferralList from './subcomponents/List'
import FilterControls from 'modules/Referral/List/subcomponents/List/Elements/filterControls'
import stylesReferralList from 'modules/Referral/List/subcomponents/List/referral-list.module.scss'
import { ROUTES } from 'constants/routes'
import { notificationShow } from 'modules/Notifications/actions'
import { Link } from 'react-router-dom'
import PageHeader from 'components/PageHeader'

const Referrals = () => {
  const dispatch = useDispatch()
  const writeToClipboard = useWriteToClipboard()
  const [isOpen, setOpen] = useState(false)
  const { t } = useTranslation(['referral'])
  const pathGen = useGeneratePathI18n()
  const [limit] = useState(50)
  const [page, setPage] = useState(1)

  const { i18n, info, list } = useSelector(
    (state) => ({
      i18n: state['app'].i18n,
      info: state['referral/list'].info,
      list: state['referral/list'].list,
    }),
    shallowEqual,
  )

  useEffect(() => {
    dispatch({ type: 'REFERRAL/FETCH_INFO' })
  }, [])

  useEffect(() => {
    setPage(1)
    dispatch({ type: 'REFERRAL/DROP_DATA' })
  }, [list.sort, list.query])

  useEffect(() => {
    dispatch({
      type: 'REFERRAL/FETCH_LIST',
      payload: {
        query: list.query,
        limit,
        offset: (page - 1) * limit,
        sort: list.sort.prop,
        direction: list.sort.direction,
      },
    })
  }, [list.query, page])

  useEffect(() => {
    list.data.length > 0 &&
      dispatch({
        type: 'REFERRAL/FETCH_LIST',
        payload: {
          query: list.query,
          limit,
          offset: (page - 1) * limit,
          sort: list.sort.prop,
          direction: list.sort.direction,
        },
      })
  }, [list.sort])

  const onClickHandle = useCallback(
    (text) => {
      writeToClipboard(text)

      dispatch(
        notificationShow({
          type: 'success',
          message: 'common::notifications.success_copy_notification',
        }),
      )
    },
    [writeToClipboard],
  )

  const changePage = useCallback((val) => setPage(page + val), [page])

  return (
    <Container className={styles['container']}>
      <div className={'margin-bottom-32'}>
        <PageHeader
          className={'margin-bottom-8'}
          color={'Label-Primary'}
        >
          {t('title')}
        </PageHeader>
        <Typography
          variant={'Body-20'}
          color={'Label-Secondary'}
          className={styles['subtitle']}
          noMargin
        >
          {t('subtitle')}
        </Typography>
      </div>
      <div className={styles['rules-content']}>
        <Typography
          variant={'Body-20'}
          color={'Label/Fifth'}
        >
          {t('description1')}
        </Typography>
        <Typography
          variant={'Body-20'}
          color={'Label/Fifth'}
        >
          {t('description2')}
        </Typography>
        {info && info.rules && (
          <Collapse isOpened={isOpen}>
            <div
              dangerouslySetInnerHTML={{
                __html: info.rules[i18n]?.content,
              }}
            />
          </Collapse>
        )}
      </div>

      <div className={styles['link-container']}>
        {info && info.rules && (
          <Button
            className={styles['link']}
            variant={'ghost'}
            link
            onClick={() => setOpen(!isOpen)}
            color={'Label-GU-Primary'}
          >
            {t(isOpen ? 'rules_hide' : 'rules_show')}
          </Button>
        )}
      </div>

      <div className={'margin-bottom-16'}>
        <TextInput
          readOnly
          className={styles['ref-input']}
          label={t('your_code')}
          fullWidth
          disabled
          value={info.url}
          InputProps={{
            className: styles['input'],
            startAdornment: info.loading ? (
              <Spinner
                width={16}
                color={'Label-GU-Primary'}
              />
            ) : null,
            endAdornment: (
              <span
                className={styles['copy-link-anchor']}
                onClick={() => onClickHandle(info.url)}
              >
                {t('copy')}
              </span>
            ),
          }}
        />
      </div>
      <Container
        display={'flex'}
        flexAlign={'center'}
        flexJustify={'space-between'}
        className={styles['balance__container']}
      >
        <span>
          {t('referral_balance')}:
          {!info?.referrer_award_amount ? (
            <Spinner
              width={16}
              className={styles['balance__value']}
            />
          ) : (
            <span
              className={styles['balance__value']}
              dangerouslySetInnerHTML={{
                __html: format(
                  info.referrer_award_amount.amount,
                  info.referrer_award_amount.currency,
                ),
              }}
            />
          )}
        </span>

        <Button
          variant={'primary'}
          disabled={!info?.referrer_award_amount?.amount}
          component={!info?.referrer_award_amount?.amount ? 'button' : Link}
          size={'s'}
          bgColor={'Label-GU-Primary'}
          className={styles['balance__withdrawal']}
          to={!info?.referrer_award_amount ? null : pathGen(ROUTES.REFERRAL_PAYOUT)}
          endIcon={
            !info?.referrer_award_amount ? (
              <Spinner
                width={16}
                color={'inherit'}
              />
            ) : (
              <Icon
                name={'arrow-right'}
                size={'s'}
                color={'white'}
              />
            )
          }
        >
          {t('withdrawal_link_label')}
        </Button>
      </Container>

      <FilterControls />

      <ReferralList
        className={stylesReferralList['referral-list__container']}
        onChangePage={changePage}
        loading={list.loading}
        data={list.data}
        pagination={list.pagination}
      />

      {/*{list.loading && list.data.length === 0 ? (*/}
      {/*  <Container*/}
      {/*    display={'flex'}*/}
      {/*    flexJustify={'center'}*/}
      {/*    className={stylesReferralList['referral-list__spinner']}*/}
      {/*  >*/}
      {/*    <Spinner width={40} color={'Label-GU-Primary'} />*/}
      {/*  </Container>*/}
      {/*) : (*/}
      {/*  <ReferralList*/}
      {/*    className={stylesReferralList['referral-list__container']}*/}
      {/*    onChangePage={changePage}*/}
      {/*    loading={list.loading}*/}
      {/*  />*/}
      {/*)}*/}
    </Container>
  )
}

export default Referrals
